import Vue from 'vue';
import axios, { AxiosStatic } from 'axios';
import VueAxios from 'vue-axios';

Vue.prototype.$axios = axios;
declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
  }
}

// axios.defaults.headers.common.Authorization = process.env.VUE_APP_API_KEY;
// axios.defaults.headers.common.Authorization = window.localStorage.getItem('token');
// axios.defaults.headers.common['X-Custom-Header'] = 'mobilecool/admin';

export default (isPost: boolean = false) => axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer ' + window.localStorage.getItem('token'),
    'X-Custom-Header': 'mobilecool/admin',
  },
  timeout: 12000,
  transformResponse: [
    function (data) {
      // console.log(data);
      return isPost ? data : JSON.parse(data);
    },
  ],
});

Vue.use(VueAxios, axios);
